import { useEffect, useState } from "react";
import { Recommendation as RecommendationType } from "../../types";
import { useApiData } from "../../contexts/ApiData";
import { useTranslations } from "../../contexts/Translation";
import Link from "../Link/Link";
import Recommendation from "../Recommendations/Recommendation";
import styles from "./Recommendation.module.css";

const RandomRecommendation = ({ recommendations: given }: { recommendations?: RecommendationType[] }) => {
  const { get } = useApiData();
  const [recommendations, setRecommendations] = useState<RecommendationType[]>([]);
  const [highlighted, setHighlighted] = useState<RecommendationType | undefined>(undefined);
  const t = useTranslations("dashboard");

  useEffect(() => {
    const pick = (recs: RecommendationType[]) => {
      setRecommendations(recs);
      setHighlighted(recs[Math.floor(Math.random() * recs.length)]);
    };
    if (given) {
      pick(given);
      return;
    }
    const call = async () => {
      const recs = await get(`/recommendations`);
      if (recs) {
        pick(recs);
      }
    };
    call();
  }, [get, given]);

  if (recommendations.length === 0 || !highlighted) {
    return null;
  }

  return (
    <>
      <Recommendation recommendation={highlighted} />
      <p className={styles.linkRow}>
        <Link href='/recommendations'>{t("seeMoreRecommendations")}</Link>
      </p>
    </>
  );
};

export default RandomRecommendation;
